import {
  Box,
  Button,
  SpaceBetween,
  TextContent,
} from '@cloudscape-design/components';
import React from 'react';
import { GameScored as IGameScored, Player } from '../../api';

export interface GameScoredProps {
  game: IGameScored;
  onRestartGame?: () => void;
}

export const GameScored: React.FC<GameScoredProps> = ({
  onRestartGame,
  game,
}) => {
  const getScore = (p: Player): number => {
    return game.scores[p.name].points;
  };
  const playerWithPointsText = (p: Player): JSX.Element => {
    return (
      <>
        <strong>{p.name}</strong> with <strong>{getScore(p)}</strong> points
      </>
    );
  };
  const maxPoints = Math.max(...game.players.map((p) => getScore(p)));

  const winners = game.players.filter(
    (p) => game.scores[p.name].points === maxPoints
  );
  const losers = game.players.filter((p) => !winners.includes(p));
  const winnersLi = winners.map((p, idx) => (
    <li key={p.name}>
      <strong>{p.name}</strong>
      {idx === winners.length - 1 ? '.' : ','}
    </li>
  ));

  const losersLi = losers.map((p, idx) => (
    <li key={p.name}>
      {playerWithPointsText(p)}
      {idx === winners.length - 1 ? '.' : ','}
    </li>
  ));
  return (
    <>
      <TextContent>
        <h2>Game is finished</h2>
        <p>
          The winner
          {winners.length > 1 ? (
            <>
              s with <strong>{getScore(winners[0])}</strong> points are
            </>
          ) : (
            ' is'
          )}
          :
        </p>
        {winners.length > 1 && <ul>{winnersLi}</ul>}
        {winners.length === 1 && (
          <p>
            {playerWithPointsText(winners[0])}
            <strong></strong> points!
          </p>
        )}
        {winners.length === 0 && <p>No winners.</p>}

        <p>The losers are:</p>
        {losersLi.length > 0 && <ul>{losersLi}</ul>}
        {losersLi.length === 0 && (
          <p>
            <strong>No losers.</strong>
          </p>
        )}
      </TextContent>
      <Box margin={{ top: 'm' }}>
        <SpaceBetween size="s" direction="horizontal">
          <Button onClick={() => onRestartGame?.()}>Restart</Button>
        </SpaceBetween>
      </Box>
    </>
  );
};
